import { Box, FormLabel, Grid, Input, Stack } from "@mui/material";
import { Button, Spin } from "antd";
import React, { memo, useEffect, useState } from "react";
import StrapiService from "../../articles/StrapiService";
import { Item } from "./styledComponent";

const ImageUploader = ({
  label,
  updateTheme,
  initialImage,
  dimensions,
  style,
}) => {
  const strapiService = new StrapiService();
  const [loading, setLoading] = useState(false);
  const [image, setImage] = useState({
    id: initialImage?.id || null,
    url: initialImage?.url || null,
  });

  const handleUpload = async (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    if (!file || !fieldName) return;

    setLoading(true);
    try {
      const existingId = image.id;
      const { url, id } = await strapiService.uploadImage(file, existingId);

      if (url) {
        setImage({ url, id });
        await updateTheme(fieldName, url);
      }
    } catch (err) {
      console.error(`Upload failed for ${fieldName}`, err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (initialImage?.url) {
      setImage({
        id: initialImage.id || null,
        url: initialImage.url,
      });
    }
  }, [initialImage]);

  return (
    <>
      <Grid xs={12} md={6} item>
        <Item elevation={0}>
          <Stack
            direction="row"
            sx={{
              alignItems: "center",
              justifyContent: "space-between",
              height: 100,
            }}
          >
            <Box>
              <FormLabel sx={{ display: "block", textAlign: "start" }}>
                {label} ({dimensions})
              </FormLabel>
              <Button
                disabled={loading}
                className="primary-btn ant-btn-primary"
                type="primary"
                loading={loading}
              >
                <label
                  htmlFor={`upload-${label}`}
                  style={{ cursor: "pointer", marginBottom: 0 }}
                >
                  Upload {label}
                </label>
              </Button>
              <Input
                type="file"
                id={`upload-${label}`}
                name={label.toLowerCase()}
                hidden
                onChange={handleUpload}
              />
            </Box>
            {loading && !image.url ? (
              <Spin />
            ) : (
              image.url && (
                <Box mt={2}>
                  <img
                    src={image.url}
                    alt={label.toLowerCase()}
                    style={{
                      ...style,
                      objectFit: "contain",
                      borderRadius: 6,
                    }}
                  />
                </Box>
              )
            )}
          </Stack>
        </Item>
      </Grid>
    </>
  );
};

export default memo(ImageUploader);
